import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(5)
    }
  },
  image: {
    width: '50%',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  textContainer: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    }
  },
  highlightContentText: {
    color: 'white',
    letterSpacing: '1px',
    lineHeight: '35px',
    textAlign: 'center',
    textTransform: 'uppercase',
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px'
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '20px'
    }
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(2)
    }
  },
  cardsContainer: {
    padding: theme.spacing(6),
    paddingBottom: theme.spacing(8)
  },
  videoWrapper: {
    height: 200,

    [theme.breakpoints.up('sm')]: {
      height: 300
    },

    [theme.breakpoints.up('md')]: {
      height: 400
    }
  }
}));

export default useStyles;
